'use client';

import { useTranslations } from 'next-intl';
import { VStack, HStack } from '@terra/ui-styled-system';
import { Text } from '../../../../../components/styled/text';
import type { ParsedAdEntityDetails } from './parse-ad-entity-details-output.util';

function DetailRow({ label, value }: { label: string; value: string }) {
  return (
    <HStack gap={2} alignItems="flex-start" width="100%">
      <Text fontSize="2xs" color="fg.muted" minW="88px" flexShrink={0}>
        {label}
      </Text>
      <Text
        fontSize="xs"
        color="fg.default"
        fontFamily="mono"
        wordBreak="break-all"
      >
        {value}
      </Text>
    </HStack>
  );
}

export function AdEntityDetailBody({
  entity,
}: {
  entity: ParsedAdEntityDetails;
}) {
  const t = useTranslations('designSystem.chat.adToolOutput');

  return (
    <VStack alignItems="stretch" gap={1.25} width="100%">
      <DetailRow label="Name" value={entity.displayName} />
      <DetailRow label="Kind" value={entity.entityKind} />
      <DetailRow label="Node ID" value={entity.nodeId} />
      <DetailRow label="Object ID" value={entity.objectId} />
      {entity.samAccountName ? (
        <DetailRow label="SAM" value={entity.samAccountName} />
      ) : null}
      {entity.distinguishedName ? (
        <DetailRow label="DN" value={entity.distinguishedName} />
      ) : null}
      {entity.isCrownJewel ? (
        <Text fontSize="2xs" color="fg.muted">
          {t('crownJewel')}
        </Text>
      ) : null}
      {entity.properties ? (
        <Text
          fontSize="2xs"
          color="fg.muted"
          fontFamily="mono"
          whiteSpace="pre-wrap"
        >
          {entity.properties}
        </Text>
      ) : null}
    </VStack>
  );
}
